import store from "../../../router";

export function useEmpresaSettings() {
    const state = store.getState();
    return state.settings && state.settings.settings;
}
